<template>
  <set-color></set-color>
</template>
<script>
import setColor from "../base/set-color";
export default {
  components: { setColor }
};
</script>
<style lang="less" scoped>
</style>


